import {
  SHOW_LOGIN_MODAL,
  SHOW_REGISTER_MODAL,
  HIDE_AUTH_MODALS,
  SHOW_ADDRESS_MODAL,
  SHOW_CONFIRMATION_MODAL,
  SHOW_CONTINUE_REGISTER_MODAL,
  SHOW_Payment_MODAL,
  TOGGLE_CONTINUE_SHOPPING_MODAL,
  TOGGLE_GUEST_CHECK_MODAL,
  CHANGE_STATE_OF_CLOSE
} from '../actions/ui';

export type UiState = {
  canClose: boolean;
  showLoginModal: boolean;
  showPaymentModal: boolean;
  showContinueRegisterModal: boolean;
  userData: any;
  showRegisterModal: boolean;
  showAddressModal: boolean;
  showConfirmationModal: boolean;
  showContinueShoppingModal: boolean;
  showGuestCheckoutModal:boolean;
  showGuest:boolean;
  emailAlreadyExists:boolean;
};

const defaultState: UiState = {
  canClose: true,
  showLoginModal: false,
  showPaymentModal: false,
  userData: {},
  showContinueRegisterModal: false,
  showRegisterModal: false,
  showAddressModal: false,
  showConfirmationModal: false,
  showContinueShoppingModal: false,
  showGuestCheckoutModal:false,
  showGuest:false,
  emailAlreadyExists:false,
};

export default (state: UiState = defaultState, action: any) => {
  switch (action.type) {
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        canClose: action.canClose,
        showLoginModal: true,
        showRegisterModal: false,
        showAddressModal: false,
        emailAlreadyExists:action.emailAlreadyExists,
        
      };

    case SHOW_REGISTER_MODAL:
      return {
        ...state,
        showLoginModal: false,
        canClose: action.canClose,
        showRegisterModal: true,
        showAddressModal: false,
      };
      
      case TOGGLE_GUEST_CHECK_MODAL:
        return {
          ...state,
          showGuestCheckoutModal:action.isShow,
          showContinueShoppingModal:false,
        };
      case SHOW_ADDRESS_MODAL:
        return {
          ...state,
          showLoginModal: false,
          showRegisterModal: false,
          showAddressModal: true,
          showGuest:action.isGuest,
          canClose: action.canClose,
      };
    case CHANGE_STATE_OF_CLOSE:
      return{
        ...state,
        canClose:action.stateOfClose
      };
    case TOGGLE_CONTINUE_SHOPPING_MODAL:
      return {
        ...state,
        showContinueShoppingModal: action.isShow,
      };

    case SHOW_Payment_MODAL:
      return {
        ...state,
        showLoginModal: false,
        showRegisterModal: false,
        showAddressModal: false,
        canClose: false,
        userData: action.userData,
        showPaymentModal: true,
      };

    case HIDE_AUTH_MODALS:
      return {
        ...state,
        showLoginModal: false,
        showRegisterModal: false,
        showAddressModal: false,
        showContinueRegisterModal: false,
        showConfirmationModal: false,
        showPaymentModal: false,
        showGuestCheckoutModal:false,
      };
    case SHOW_CONTINUE_REGISTER_MODAL:
      return {
        ...state,
        showLoginModal: false,
        showRegisterModal: false,
        showAddressModal:false,
        showGuestCheckoutModal:false,
        userData: action.userData,
        showContinueRegisterModal: true,
      };

    case SHOW_CONFIRMATION_MODAL:
      return {
        ...state,
        showLoginModal: false,
        showRegisterModal: false,
        showAddressModal: false,
        showConfirmationModal: true,
      };

    default:
      return state;
  }
};
